(function () {
  class FoodCalculator extends HTMLElement {
    constructor() {
      super();
      this.numberInput = this.querySelector('input[type="number"]');
      this.rangeInput = this.querySelector('input[type="range"]');
      this.outputMince = this.querySelector('.js-output-mince');
      this.outputMeatball = this.querySelector('.js-output-meatball');
      this.outputCost = this.querySelector('.js-output-cost');

      this.juniorInput = this.querySelector('.js-age-junior');
      this.adultInput = this.querySelector('.js-age-adult');
      this.juniorAgeBlock = this.querySelector('.js-junior-age');
      this.configsEl = document.querySelector('[data-calculator-config]');
      this.juniorAgeSelect = this.querySelector('.js-junior-age-select');

      this.juniorFootnote = this.querySelector(".js-junior-footnote")

      // initializators
      this.min = Number(this.numberInput.getAttribute('min')) || 0;
      this.max = Number(this.numberInput.getAttribute('max')) || 50;
      this.juniorAge = this.dataset.defaultJuniorAge;
      this.minPercent = Number(this.dataset.percentageMin);
      this.maxPercent = Number(this.dataset.percentageMax);
      this.defaultValue = Number(this.dataset?.defaultValue) || 25;
      this.toggleAge = this.toggleAge.bind(this);
      this.updateJuniorSelect = this.updateJuniorSelect.bind(this);
      this.handleRangeInput = this.handleRangeInput.bind(this);
      this.initialize();
    }
    updateOutput(inputValue) {
      if (!this.minPercent || !this.maxPercent) return;
      const minValue = inputValue * 1000 * this.minPercent;
      const maxValue = inputValue * 1000 * this.maxPercent;
      const minMeatboll = Math.ceil((minValue / this.configs.food.one_meatball_g) * 2) / 2;
      const maxMeatboll = Math.ceil((maxValue / this.configs.food.one_meatball_g) * 2) / 2;
      const minPrice = (minValue * this.configs.food.price_per_g).toFixed(2);

      this.outputMince.textContent = `${minValue} - ${maxValue}g`;
      this.outputMeatball.textContent = `${minMeatboll} - ${maxMeatboll}`;
      this.outputCost.textContent = `From £${minPrice} per day`;
    }

    get value() {
      return this.rangeInput.value;
    }

    set value(newValue) {
      const validValue = this.validateValue(newValue);
      this.rangeInput.value = validValue;
      this.numberInput.value = validValue;
      this.setAttribute('value', validValue);
      this.updateOutput(validValue);
    }
    parseConfigs() {
      try {
        const raw = this.configsEl?.textContent;
        if (!raw) throw new Error('Empty config');

        this.configs = JSON.parse(raw);
      } catch (error) {
        console.error('⚠️ Failed to parse configs:', error);
        this.configs = {};
      }
    }
    initialize() {
      this.parseConfigs();
      this.value = this.defaultValue;
      this.bindListeners();
    }

    updateJuniorSelect(e) {
      this.juniorAge = e.target.value;
      this.onJuniorSelect();
    }
    validateValue(value) {
      if (value < this.min) return this.min;
      if (value > this.max) return this.max;
      return value;
    }

    handleNumber = () => {
      this.value = this.numberInput.value;
    };

    handleRange = () => {
      this.value = this.rangeInput.value;
    };

    showJuniorAgeBlock(show) {
      if (show) {
        this.juniorAgeBlock.style.display = '';
        this.juniorAgeBlock.setAttribute('aria-hidden', 'false');
      } else {
        this.juniorAgeBlock.style.display = 'none';
        this.juniorAgeBlock.setAttribute('aria-hidden', 'true');
      }
    }
    onJuniorSelect() {
      this.juniorFootnote?.classList.remove('hidden')
      this.minPercent = this.configs.junior[this.juniorAge]?.min_percentage;
      this.maxPercent = this.configs.junior[this.juniorAge]?.max_percentage;
      this.updateOutput(this.value);
    }
    onAdultSelect() {
      this.juniorFootnote?.classList.add('hidden')
      this.minPercent = this.configs.adult.min_percentage;
      this.maxPercent = this.configs.adult.max_percentage;
      this.updateOutput(this.value);
    }
    toggleAge(e) {
      if (!e.target.name.includes('animal-type')) return;
      const selected = e.target.value;
      if (selected === 'junior') {
        this.showJuniorAgeBlock(true);
        this.onJuniorSelect();
      } else {
        if (this.juniorAgeBlock.contains(document.activeElement)) {
          document.activeElement.blur();
        }
        this.showJuniorAgeBlock(false);
        this.onAdultSelect();
      }
    }
    handleRangeInput(e) {
      // ? light update without validations
      this.numberInput.value = e.target.value;
    }
    bindListeners() {
      this.numberInput.addEventListener('change', this.handleNumber);
      this.rangeInput.addEventListener('change', this.handleRange);
      this.rangeInput.addEventListener('input', this.handleRangeInput);
      this.juniorInput.addEventListener('change', this.toggleAge);
      this.adultInput.addEventListener('change', this.toggleAge);
      this.juniorAgeSelect.addEventListener('change', this.updateJuniorSelect);
    }

    unbindListeners() {
      this.numberInput.removeEventListener('change', this.handleNumber);
      this.rangeInput.removeEventListener('change', this.handleRange);
      this.rangeInput.removeEventListener('input', this.handleRangeInput);
      this.juniorInput.removeEventListener('change', this.toggleAge);
      this.adultInput.removeEventListener('change', this.toggleAge);
      this.juniorAgeSelect.removeEventListener('change', this.updateJuniorSelect);
    }

    connectedCallback() {
      this.bindListeners();
    }

    disconnectedCallback() {
      this.unbindListeners();
    }
  }

  if (!customElements.get('food-calculator')) {
    customElements.define('food-calculator', FoodCalculator);
  }
})();
